<template>
    <div style="margin: 20px; text-align: left;">
        <h3 style="text-align: left; margin-left:20px">
            菜单管理
        </h3>
        <div style="text-align: right;">
            <el-button @click="showAdd" type="primary">添加</el-button>
        </div>
        <div style="margin-top: 20px;">
            <el-table  v-loading="loading" :data="tableData" border default-expand-all  row-key="id">
                <el-table-column prop="id"  label="编号" />
                <el-table-column prop="code" label="CODE" />
                <el-table-column prop="name"  label="名称"/>
                <el-table-column label="操作" fixed="right">
                    <template #default="scope">
                        <el-popconfirm title="确认删除吗？" @confirm="itemDelete(scope.row)">
                            <template #reference>
                                <el-button link type="danger">删除</el-button>
                            </template>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
    <el-dialog style="text-align:left" v-model="addVisiable" title="新增" width="500" :before-close="handleClose">
        <el-form label-position='top' ref="addFormRef" :rules="formRules" :model="addForm">
            <el-form-item label='CODE' prop="code">
                <el-input v-model="addForm.code"></el-input>
            </el-form-item>
            <el-form-item label='名称' prop="name">
                <el-input v-model="addForm.name"></el-input>
            </el-form-item>
            <el-form-item label='父级' prop="pid">
                <el-select v-model="addForm.pid">
                    <el-option v-for="item in optionOptions" :key="item.key" :value="item.value" :label="item.label"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" @click="add(addFormRef)">
                    添加
                </el-button>
            </div>
        </template>
    </el-dialog>



</template>



<script setup>
import { ref, onMounted, reactive } from 'vue'
import api from './api.js'
import { ElMessage } from "element-plus";


const tableData = ref([]);
const loading = ref(false)

const addVisiable = ref(false)


const addFormRef = ref()
const uploadRef = ref()
const formRules = ref({
    code: [{ required: true, message: '请填写CODE' }],
    name: [{ required: true, message: '请填写名称' }],
    pid: [{ required: true, message: '请选择父目录' }],

})

let addForm = reactive({
    code: '',
    pid: 0,
    name: '',
})
const optionOptions = ref([{
        key:"first",
        value:0,
        label:"第一级"
    }])


function showAdd() {

    addVisiable.value = true
}

onMounted(() => {
    getData()

    api.simple({"pid-eq":0}).then(res => {
    res.data.forEach(element => {
        optionOptions.value.push({
                    key:element.code,
                    value:element.id,
                    label:element.name
        })
        
    });
    })
})

function handleClose() {
    resetForm()
    addVisiable.value = false;
}
function itemDelete(row) {
    api.delete(row.id).then(() => {
        getData()
    })
}

function getData() {
    loading.value = true
    api.index({
    }).then(res => {
        loading.value = false
        tableData.value = res.data
    })
}



async function add() {
    addFormRef.value.validate((valid) => {
        if (valid) {
            api.add(addForm).then(res => {
                if (res?.code !== 0) {
                    ElMessage.error(res?.message | 'add error')
                    return
                }
                addVisiable.value = false
                getData()
                resetForm()
            })
        }
    })




}
function resetForm() {
    addFormRef.value?.resetFields()
    uploadRef.value?.clearFiles()

}


</script>
